import { Box, Grid2, Paper } from '@mui/material';
import React, { Suspense, useEffect, useMemo } from 'react';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { FilterList, SummarizeTwoTone } from '@mui/icons-material';
import Tabla from '../../../../components/ui/materialui/tabla';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import useInformeDesg from '../hooks/useInformeDesg';
import { useColumns } from '../utils/columns';
import CustomAccordion from '../../../../components/ui/materialui/customAccordion';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import { TipoSeguro } from '../../../../utils/enums';
import useConsultarRemesas from '../../consultarRemesas/hooks/useConsultarRemesas';
import { descargarReporteInfDesgravamen } from '../../../detalleMutuo/services/servicesReportes';

interface FiltroBandeja {
    companiaSeguro: string;
    fechaRemesa: Date;
    codigoPoliza: string;
}

const InformeDesg: React.FC = () => {

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
    } = useForm<FiltroBandeja>({
        // resolver: yupResolver(validationSchema)
    })
    const { obtenerInformeDesg,setData, data } = useInformeDesg();
    const { consultarCompania, consultarPoliza, compania, poliza } = useConsultarRemesas();
    const { COLUMNS } = useColumns();
    const columns = useMemo(() => COLUMNS, [COLUMNS]);
    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Remesas', url: `/remesas` },
        { label: 'Informe Desgravamen', active: true },
    ];

    const onSubmit = (data: FiltroBandeja) => {       
        setData([]); 
        obtenerInformeDesg(TipoSeguro.DESGRAVAMEN, data.companiaSeguro, data.codigoPoliza, data.fechaRemesa);

    }
    const emitirSeguroDesgravamen = async () => {
        await descargarReporteInfDesgravamen(data);
    }

    useEffect(() => {
        consultarCompania();
        // consultarPoliza(defaultValues.companiaSeguros)
        // eslint-disable-next-line
    }, [])

    const handleChangeCompania = async (value: string | null) => {
        if (!value)
            return;

        await consultarPoliza(value);
    }

    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
                <Paper elevation={3} sx={{ p: 3 }}>
                    <CustomAccordion
                        title='Filtros'
                        expandedDefault
                    >
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                                <Grid2 size={3}>
                                    <InputSelect
                                        name="companiaSeguro"
                                        label="Compañía seguro"
                                        control={control}
                                        onChange={handleChangeCompania}
                                        error={errors.companiaSeguro}
                                        options={compania}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputFecha
                                        name="fechaRemesa"
                                        control={control}
                                        label="Fecha de Remesa"
                                        error={errors.fechaRemesa}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        name="codigoPoliza"
                                        control={control}
                                        options={poliza}
                                        label="Código póliza"
                                        error={errors.codigoPoliza}
                                    />
                                </Grid2>
                                <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                    <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                        Filtrar
                                    </MButton>
                                </Grid2>
                            </Grid2>
                        </form>
                    </CustomAccordion>


                    <Suspense>
                        <Grid2>
                            <Tabla
                                columns={columns}
                                data={data}
                                titulo={<TableHeader
                                    // title="Listado participantes"
                                    buttonExport={
                                        <>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                startIcon={<SummarizeTwoTone />}
                                                disabled={data.length === 0}
                                                onClick={() => emitirSeguroDesgravamen()}
                                            // onClick={() => exportExcel(listaParticipantes, columns, "Listado-Participantes")}
                                            >
                                                Emitir resumen
                                            </MButton>
                                        </>
                                    }
                                />}
                            />
                        </Grid2>
                    </Suspense>
                </Paper>
            </Box>
        </Suspense>
    );
};

export default InformeDesg;